module.exports = fox._r("images/mc_intro.png", __webpack_public_path__ + "images/mc_intro.png");


//////////////////
// WEBPACK FOOTER
// ./images/mc_intro.png
// module id = 73
// module chunks = 2